import React from 'react';
import LottieAnimation from '../LottieAnimation';
import loader from '../../helpers/lottie-files/loader.json'

function FileLoader(props) {
    return (
        <LottieAnimation loop={true} animateFile={loader} width={150} height={150} />
    );
}

export default FileLoader;